import { useContext } from "react";
import { UserDataContext } from "../routes/Main";

export default function isIntern() {
    const { userData } = useContext(UserDataContext);
    return (
        userData?.data?.roles[0]?.name === 'int'
            ? true
            : false
    )
}
